import HandoverTicketDetail from './HandoverTicketDetail';

export default HandoverTicketDetail;
